'use strict';

/**
 * Period sub-classification types stored in the `workpackagePeriodType` field.
 * Separate from `workpackage-types.js` which controls the `type` field.
 * null (default) means no period type assigned.
 * XSR-specific at launch.
 */
module.exports = {
  weekly: 'weekly',
  aoPeriod: 'aoPeriod',
};
